'use strict'

import RightshipInspectorList from "@/components/settings/rightship-inspection/RightshipInspectorList.vue";
import RightshipInspectionSettings from "@/components/settings/rightship-inspection/RightshipInspectionSettings.vue";
import RightshipCompanyList from "@/components/settings/rightship-inspection/RightshipCompanyList.vue";

const Settings = () => import('@/views/Settings')
const SettingsUsers = () => import('@/components/settings/SettingsUsers')
const SettingsExchangeRates = () => import('@/components/settings/SettingsExchangeRates')
const SettingsExchangeRatesCurrencies = () => import('@/components/settings/SettingsExchangeRatesCurrencies.vue')
const SettingsUserProfile = () => import('@/components/settings/user/Profile')
const SettingsCurrencies = () => import('@/components/settings/SettingsCurrencies')
const SettingsSisterShip = () => import('@/components/settings/SisterShip')
const SettingsManagingVessel = () => import('@/components/settings/ManagingVessel')
const SettingsChecklistMain = () => import('@/components/settings/internal-audit/checklist/SettingsChecklistMain.vue')
const SettingsShipBuilder = () => import('@/components/settings/SettingsShipBuilder.vue')
const SettingsShipAuditSchedule = () => import('@/components/settings/SettingsShipAuditSchedule.vue')
const SettingsHistoryLogs = () => import('@/components/settings/HistoryLogs.vue')
const SettingsEngineMaker = () => import('@/components/settings/SettingEngineMaker')
const SettingsEngineType = () => import('@/components/settings/SettingEngineType')
const SettingsDgMaker = () => import('@/components/settings/SettingsEngineDgMaker')
const SettingsDgType = () => import('@/components/settings/SettingsEngineDgType')
const SettingsTcMaker = () => import('@/components/settings/SettingsEngineTcMaker')
const SettingsTcType = () => import('@/components/settings/SettingsEngineTcType')
const SettingsAuxMaker = () => import('@/components/settings/SettingsEngineAuxMaker')
const SettingsAuxType = () => import('@/components/settings/SettingsEngineAuxType')
const SettingsRelatedParty = () => import('@/components/settings/SettingsRelatedParty')
const SettingAnnouncement = () => import('@/components/settings/announcement/Index.vue')
const SettingEmails = () => import('@/components/settings/emails/SettingEmails.vue')
const EmailDetails = () => import('@/components/settings/emails/EmailDetails.vue')

const SettingQuestionnaire = () => import('@/components/settings/questionnaires/RightShipQuestionnaires.vue')

const SettingRevision = () => import('@/components/settings/revisions/RevisionNumbers.vue')
const SettingInspection = () => import('@/components/settings/rightship-inspection/RightshipInspectionSettings.vue')
const SettingInspector = () => import('@/components/settings/rightship-inspection/RightshipInspectorList.vue')
const SettingCompany = () => import('@/components/settings/rightship-inspection/RightshipCompanyList.vue')

export const RouteSettings = {
  path: 'settings/',
  name: 'SettingsWrapper',
  component: Settings,
  redirect: 'settings/users',
  children: [
    {
      path: 'announcement',
      name: 'SettingAnnouncement',
      component: SettingAnnouncement,
    },
    {
      path: 'emails',
      name: 'SettingEmails',
      component: SettingEmails,
    },
    {
      path: 'email/:email_id/:active_module',
      name: 'EmailDetails',
      component: EmailDetails,
    },
    {
      path: 'questionnaires',
      name: 'SettingQuestionnaire',
      component: SettingQuestionnaire
    },
    {
      path: 'revisions',
      name: 'SettingRevision',
      component: SettingRevision
    },
    {
      path: 'inspection-settings',
      name: 'SettingInspection',
      component: RightshipInspectionSettings
    },
    {
      path: 'inspector-list',
      name: 'SettingInspector',
      component: RightshipInspectorList
    },
    {
      path: 'company-list',
      name: 'SettingCompany',
      component: RightshipCompanyList
    },
    {
      path: 'users',
      name: 'SettingsUsers',
      component: SettingsUsers,
    },
    {
      path: 'exchange-rates',
      name: 'SettingsExchangeRates',
      component: SettingsExchangeRates,
    },{
      path: 'exchange-rates-currencies',
      name: 'SettingsExchangeRatesCurrencies',
      component: SettingsExchangeRatesCurrencies,
    },
    {
      path: 'users/:id/',
      name: 'SettingsUserProfile',
      component: SettingsUserProfile,
      redirect: 'users/:id/role-permission',
      children: [
        {
          path: 'role-permission',
          name: 'RoleAndPermission',
          component: () => import(/* webpackChunkName: "user-change-password" */ '../components/settings/user/RoleAndPermission'),
        },
        {
          path: 'change-pass',
          name: 'ChangePassword',
          component: () => import(/* webpackChunkName: "user-change-password" */ '../components/settings/user/ChangePassword'),
        },
        {
          path: 'user-vessels',
          name: 'UserVessels',
          component: () => import(/* webpackChunkName: "user-change-password" */ '../components/settings/user/UserVessels'),
        },
        {
          path: 'reset-pass',
          name: 'ResetPassword',
          component: () => import(/* webpackChunkName: "user-change-password" */ '../components/settings/user/ResetPassword'),
        },
      ]
    },
    {
      path: 'currencies',
      name: 'SettingsCurrencies',
      component: SettingsCurrencies,
    },
    {
      path: 'events',
      name: 'SettingsEvents',
      component: SettingsUserProfile,
    },
    {
      path: 'causes',
      name: 'SettingsCauses',
      component: SettingsUserProfile,
    },
    {
      path: 'sister-ship',
      name: 'SisterShip',
      component: SettingsSisterShip,
    },

    {
      path: 'managing-vessel',
      name: 'ManagingVessel',
      component: SettingsManagingVessel,
    },

    {
      path: 'settings-audit-checklist',
      name: 'SettingsChecklistMain',
      component: SettingsChecklistMain,
    },

    {
      path: 'ship-builder',
      name: 'ShipBuilder',
      component: SettingsShipBuilder,
    },
    {
      path: 'ship-audit-schedule',
      name: 'ShipAuditSchedule',
      component: SettingsShipAuditSchedule,
    },

    {
      path: 'history-logs',
      name: 'HistoryLogs',
      component: SettingsHistoryLogs,
    },

    {
      path: 'engine-maker',
      name: 'EngineMaker',
      component: SettingsEngineMaker,
    },
    {
      path: 'engine-type',
      name: 'EngineType',
      component: SettingsEngineType,
    },
    {
      path: 'engine-dg-maker',
      name: 'EngineDgMaker',
      component: SettingsDgMaker,
    },

    {
      path: 'engine-dg-type',
      name: 'EngineDgType',
      component: SettingsDgType,
    },

    {
      path: 'engine-tc-maker',
      name: 'EngineTcMaker',
      component: SettingsTcMaker,
    },

    {
      path: 'engine-tc-type',
      name: 'EngineTcType',
      component: SettingsTcType,
    },

    {
      path: 'engine-aux-maker',
      name: 'EngineAuxMaker',
      component: SettingsAuxMaker,
    },

    {
      path: 'engine-aux-type',
      name: 'EngineAuxType',
      component: SettingsAuxType,
    },
    {
      path: 'related-party',
      name: 'RelatedParty',
      component: SettingsRelatedParty,
    },
  ]
};
